import React from 'react';
import PropTypes from 'prop-types';

import { hideModal, showModal } from 'Store/ui/actions';
import Lightbox from 'Components/Lightbox';
import { connect } from 'react-redux';
import { isModalActive } from 'Store/reducers';
import styles from './EditEnabledModulesForm.scss';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import UsersListAction from 'Components/UsersListAction';
import EditEnabledModulesForm from './EditEnabledModulesForm';

const LIGHTBOX_KEY = 'edit-modules-modal';

function EditEnabledModulesLightbox(props) {
  const {
    onSubmit,
    disabledModules,
    isModalActive,
    hideModal,
    showModal,
  } = props;

  return (
    <React.Fragment>
      <UsersListAction
        iconType="pencil"
        label={
          <ConnectedFormattedMessage id="explore_models.edit_enabled_modules_button.label" />
        }
        handleClick={() => {
          showModal(LIGHTBOX_KEY);
        }}
      />
      <Lightbox
        visible={isModalActive}
        closeHandler={() => hideModal(LIGHTBOX_KEY)}
        type="edit-modules-modal"
      >
        <div>
          <EditEnabledModulesForm
            disabledModules={disabledModules}
            onSubmit={(disabledModels) => {
              onSubmit(disabledModels);
              hideModal(LIGHTBOX_KEY);
            }}
          />
        </div>
      </Lightbox>
    </React.Fragment>
  );
}

EditEnabledModulesLightbox.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  disabledModules: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => {
  return {
    isModalActive: isModalActive(state, LIGHTBOX_KEY),
  };
};

export default connect(mapStateToProps, {
  showModal,
  hideModal,
})(EditEnabledModulesLightbox);
